import { create } from "zustand";
import { AppRecordJK, AppRecordStatusJK, RequestApi, RouteApi, StatusMsg } from "utils";
import { AppLog } from "services";
import { Service } from "utils/services";

interface NewFeedStoriesState {
  stories: any[];
  appRecord: AppRecordJK;
  existingIds: Set<string>;
  initializePage: () => Promise<void>;
  fetchStories: (isRefresh: boolean) => Promise<void>;
}

const newFeedStoriesStore = create<NewFeedStoriesState>((set, get) => ({
  stories: [],
  appRecord: new AppRecordJK(),
  existingIds: new Set<string>(),

  initializePage: async () => {
    try {
      set({
        stories: [],
        appRecord: new AppRecordJK(),
        existingIds: new Set<string>(),
      });

      newFeedStoriesStore.getState().fetchStories(true);
    } catch (error) {
      AppLog.show({
        message: `[initializePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },

  fetchStories: async (isRefresh: boolean) => {
    const { stories, existingIds, appRecord } = get();

    if (isRefresh === false) {
      if (appRecord.canLoadMore() === false) {
        return;
      }
    }

    let tmpAppRecord = new AppRecordJK({ ...appRecord });
    let tmpExistingIds = new Set(existingIds);
    let tmpStories = [...stories];

    try {
      let url: string = "";
      url = RouteApi.getNewsFeedStoryWeb;
      url += `token=${Service.token}`;

      if (isRefresh) {
        tmpAppRecord.loadingStatus = AppRecordStatusJK.loading;
        tmpExistingIds = new Set<string>();
        tmpStories = [{ id: 0 }];
        set({
          appRecord: tmpAppRecord,
          stories: tmpStories,
          existingIds: tmpExistingIds,
        });
      } else {
        if (tmpAppRecord.canLoadMore()) {
          tmpAppRecord.loadingStatus = AppRecordStatusJK.loadingMore;
          set({ appRecord: tmpAppRecord });
        } else {
          return;
        }
      }

      const existingIdsArray: string[] = [...tmpExistingIds];
      const data = {
        excluded_user_ids: existingIdsArray,
        application_type: "web",
      };

      const responses = await RequestApi(url, { data });
      if (responses.status === "success") {
        const newUsers: any[] = structuredClone(responses.users);

        const newStories: any[] = [];

        newUsers.forEach((user: any) => {
          if (user.posts && user.posts.length > 0) {
            const indexLastViewPost = user.posts.findLastIndex((post: any) => `${post.is_viewed}` === "1");

            if (indexLastViewPost > -1) {
              newStories.push(indexLastViewPost === user.posts.length - 1 ? user.posts[0] : user.posts[indexLastViewPost + 1]);
            } else {
              newStories.push(user.posts[0]);
            }
          }

          tmpExistingIds.add(`${user.id}`);
        });

        if (newUsers && newUsers.length > 0) {
          tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
        } else {
          tmpAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
        }

        set({
          appRecord: tmpAppRecord,
          existingIds: tmpExistingIds,
          stories: [...tmpStories, ...newStories],
        });
      } else {
        tmpAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
        set({ appRecord: tmpAppRecord });
      }
    } catch (error) {
      tmpAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
      set({ appRecord: tmpAppRecord });

      AppLog.show({
        message: `[fetchStories]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
}));

export default newFeedStoriesStore;

